import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-mailing',
  templateUrl: './mailing.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrl: './mailing.component.scss'
})
export class MailingComponent {

}
